import React, { useContext } from "react";
import {DocLogo} from "../../../shared/DocLogo/DocLogo";
import {WhiteLabelLogo} from "../../../shared/WhiteLabelLogo/WhiteLabelLogo";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import OwTranslate from "../../../shared/OwTranslate/OwTranslate";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import moment from "moment-timezone";
import IPackingListViewOptions from "../../../../models/IPackingListViewOptions";
import SupplierContext from "../../../../contexts/SupplierContext";
import IAddress from "../../../../models/IAddress";
import _ from "lodash";
import IPacking_List from "../../../../models/IPacking_List";
import IOrder from "../../../../models/IOrder";

type Props = {
    packingList: IPacking_List;
    view: IPackingListViewOptions;
    pageSize: "STANDARD" | "MINIMAL";
    firstOrder: IOrder;
};

export const PackingListDetailTopRow = (props: Props) => {
    const supplierModel = useContext(SupplierContext);

    const supplierShipTo: IAddress = _.get(props.packingList, "Supplier.Ship_To", {} as IAddress);

    return <div className={"PackingListDetailTopRow"}>
        <div className={"top-row"}>
            <div className={"d-flex justify-content-between"}>
                <div className={" p-1 " + (props.view.inlineLogoName ? "d-flex" : "")}>
                    {supplierModel.Doc_Logo ? (
                        <DocLogo
                            maxWidth={props.pageSize === "STANDARD" ? "20rem" : "10rem"}
                            maxHeight={"8rem"}
                            height={"auto"}
                        />
                    ) : (
                        <WhiteLabelLogo maxWidth={"20rem"} />
                    )}
                    {props.view.hideBusinessName ? null : (
                        <div className={props.view.inlineLogoName ? "ms-4" : ""}>
                            <OwTitle
                                disableTranslation={true}
                                title={supplierModel.name}
                                tag={"h5"}
                                className={"mb-0"}
                            />
                            <div>{supplierShipTo.address_line_one}</div>
                            <div>{supplierShipTo.address_line_two}</div>
                            <div>
                                {supplierShipTo.city}
                                {supplierShipTo.state?.length ? "," : ""} {supplierShipTo.state} {supplierShipTo.postal_code}
                            </div>
                            <div className={"mt-2"}>
                                {supplierModel.has_user_detail_on_packing_list ? (
                                    <div>
                                        <b>{props.firstOrder.User?.name}</b>
                                    </div>
                                ) : null}
                                <div
                                    className={
                                        props.view.showPhone && (supplierShipTo.phone?.length || props.firstOrder.User?.phone?.length)
                                            ? ""
                                            : "d-none"
                                    }>
                                    <b>
                                        <OwTranslate defaultMessage={"phone"} id={"phone"} />:
                                    </b>{" "}
                                    {supplierModel.has_user_detail_on_packing_list
                                        ? props.firstOrder.User?.phone || ""
                                        : supplierShipTo.phone}
                                </div>
                                <div className={props.view.showEmail && supplierModel.email ? "" : "d-none"}>
                                    <b>
                                        <OwTranslate defaultMessage={"email"} id={"email"} />:
                                    </b>{" "}
                                    {supplierModel.has_user_detail_on_packing_list
                                        ? props.firstOrder.User?.email || ""
                                        : supplierModel.email}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <div className={"text-end align-items-end d-md-flex flex-column"}>
                    <OwTitle title={"packing_list"} tag={"h3"} isBold={true} />
                    { props.view.showPackingListName? <p className={"mt-2"}>{props.packingList.name}</p> : null }
                    <div>
                        <OwLabel title={"date"} postText={":"} /> {moment().format("MM/DD/YYYY")}
                    </div>
                    {props.firstOrder.allow_substitutions ? (
                        <p className={"mt-2"}>
                            <OwLabel title={"allow_substitutions"} />
                        </p>
                    ) : null}
                    {props.firstOrder.allow_backorders ? (
                        <p className={"mt-2"}>
                            <OwLabel title={"allow_backorders"} />
                        </p>
                    ) : null}
                    {props.firstOrder.is_local_pickup ? (
                        <p className={"mt-4"}>
                            <OwTitle title={"local_pickup"} tag={"h4"} />
                        </p>
                    ) : null}
                    {props.firstOrder.is_local_delivery ? (
                        <p className={"mt-4"}>
                            <OwTitle title={"local_delivery"} tag={"h4"} />
                        </p>
                    ) : null}
                </div>
            </div>
        </div>
    </div>;
};
